
// Subscription Model
export class Subscription {
  constructor(data = {}) {
    this.id = data.id || null;
    this.planType = data.planType || null;
    this.status = data.status || 'expired';
    this.startDate = data.startDate ? new Date(data.startDate) : null;
    this.endDate = data.endDate ? new Date(data.endDate) : null;
  }
}